import { trackEvent } from '../services/usage'

const pathOf = (res) => {
  try { return new URL(res.url).pathname } catch (e) { return '' }
}

export const checkResponse = async (res) => {
  if (!res.ok) {
    // 401 is a normal "not logged in" answer, everything else is worth a record
    if (res.status !== 401) trackEvent('api.fail', { path: pathOf(res), status: res.status })
    return res.json()
      .catch(() => {
        throw res.statusText
      })
      .then(json => {
        throw json
      })
  } else if (res.status === 201) {
    return null
  } else {
    return res.json()
  }
}
